<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="scss">
@import url('~@/assets/css/_reset.scss');
@import url('~@/assets/css/_font.scss');
@import url('~@/assets/css/_common.scss');
</style>
